export * from '@primeuix/themes/nora/imagecompare';
export { default } from '@primeuix/themes/nora/imagecompare';
